"use strict";

const MaptoolMap = () => {
    const init = () => {
        let $mapHolder = $('.js-maptool-map');
        
        if($mapHolder.length){
            var marker = [];
            var hlp_marker = [];
            var zoom = 9;
            
            $(function () {
                let $map = $('.js-map');
                let lat = parseFloat($map.data('lat'));
                let lng = parseFloat($map.data('lng'));
                let pin = $map.data('pin');
                let activePin = $map.data('active-pin') !== undefined ? $map.data('active-pin') : $map.data('pin');
                zoom = $map.data('zoom');
                let locations = $map.data('locations');
                let hlpLocations = $map.data('hlp-locations');
                
                let map_obj = new google.maps.Map($map[0], {
                    center: {lat, lng},
                    zoom: parseFloat(zoom),
                    disableDefaultUI: true,
                    styles: [
                        {
                            "featureType": "landscape",
                            "stylers": [{ "saturation": -100 }, { "lightness": 65 }, { "visibility": "on" }]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [{ "saturation": -100 }, { "lightness": 51 }, { "visibility": "simplified" }]
                        },
                        {
                            "featureType": "road.highway",
                            "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }]
                        },
                        {
                            "featureType": "road.arterial",
                            "stylers": [{ "saturation": -100 }, { "lightness": 30 }, { "visibility": "on" }]
                        },
                        {
                            "featureType": "road.local",
                            "stylers": [{ "saturation": -100 }, { "lightness": 40 }, { "visibility": "on" }]
                        },
                        {
                            "featureType": "transit",
                            "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }]
                        },
                        {
                            "featureType": "administrative.province",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "on" }, { "lightness": -25 }, { "saturation": -100 }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [{ "hue": "#ffff00" }, { "lightness": -25 }, { "saturation": -97 }]
                        }
                    ]
                });

                addLocationsToMap(map_obj, pin, activePin, locations, hlpLocations, true);
            });
        }

        function addLocationsToMap(map, pin, hlpPin, locations, hlpLocations, hasClickFunction) {
            const icon = {
                url: pin,
                scaledSize: new google.maps.Size(37, 61),
            }

            const hlpIcon = {
                url: hlpPin,
                scaledSize: new google.maps.Size(37, 61),
            }

            let i = 0;
            locations.forEach((item) => {
                if (item.latitude && item.longitude) {
                    marker[i] = new google.maps.Marker({
                        position: {
                            "lat": parseFloat(item.latitude),
                            "lng": parseFloat(item.longitude)
                        },
                        map: map,
                        icon: icon,
                    });
                    marker[i]['id'] = i;
                    if(hasClickFunction){
                        google.maps.event.clearInstanceListeners(marker[i]);
                        marker[i].addListener('click', function () {
                            marker.forEach((item) => {
                                if(item.id == this.id){
                                    item.setAnimation(google.maps.Animation.BOUNCE);
                                }else{
                                    item.setAnimation(null);
                                }
                            });
                            let latLng = this.getPosition();
                            map.setCenter(latLng);
                            let $listings = $('.js-map-location');
                            $listings.removeClass('active');
                            let $listing = $listings.filter('[data-id="'+this.id+'"]');
                            $listing.addClass('active');
                            $('#map .menu .locations .list .item[data-id="'+this.id+'"]').click();
                        });
                    }
                    i++;
                }
            });

            i = 0;
            hlpLocations.forEach((item) => {
                if (item.latitude && item.longitude) {
                    hlp_marker[i] = new google.maps.Marker({
                        position: {
                            "lat": parseFloat(item.latitude),
                            "lng": parseFloat(item.longitude)
                        },
                        map: map,
                        icon: hlpIcon,
                    });
                    hlp_marker[i]['id'] = i;
                    if(hasClickFunction){
                        google.maps.event.clearInstanceListeners(hlp_marker[i]);
                        hlp_marker[i].addListener('click', function () {
                            hlp_marker.forEach((item) => {
                                if(item.id == this.id){
                                    item.setAnimation(google.maps.Animation.BOUNCE);
                                }else{
                                    item.setAnimation(null);
                                }
                            });
                            let latLng = this.getPosition();
                            map.setCenter(latLng);
                            let $listings = $('.js-map-hlp-location');
                            $listings.removeClass('active');
                            let $listing = $listings.filter('[data-id="'+this.id+'"]');
                            $listing.addClass('active');
                            $('#map .menu .hlp-locations .list .item[data-id="'+this.id+'"]').click();
                        });
                    }
                    i++;
                }
            });

            window.unclickAllMarkers = function(){
                marker.forEach((item) => {
                    item.setAnimation(null);
                });
                hlp_marker.forEach((item) => {
                    item.setAnimation(null);
                });
            }
            
            $('.js-map-location').off('click');
            $('.js-map-location').on('click', function(){
                unclickAllMarkers();
                let $listing = $(this);
                let $listings = $('.js-map-location');
                $listings.removeClass('active');
                $listing.addClass('active');
                marker.forEach((item) => {
                    if(item.id == $listing.data('id')){
                        let latLng = item.getPosition();
                        map.setCenter(latLng);
                        item.setAnimation(google.maps.Animation.BOUNCE);
                    }
                });
            });
            
            $('.js-map-hlp-location').off('click');
            $('.js-map-hlp-location').on('click', function(){
                unclickAllMarkers();
                let $listing = $(this);
                let $listings = $('.js-map-location');
                $listings.removeClass('active');
                $listing.addClass('active');
                hlp_marker.forEach((item) => {
                    if(item.id == $listing.data('id')){
                        let latLng = item.getPosition();
                        map.setCenter(latLng);
                        item.setAnimation(google.maps.Animation.BOUNCE);
                    }
                });
            });

            $('#map .zoom .plus').click(function(){
                if(zoom < 20){
                    zoom++;
                }
                map.setZoom(zoom);
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Zoom In'
                });
            });
            $('#map .zoom .minus').click(function(){
                if(zoom > 5){
                    zoom--;
                }
                map.setZoom(zoom);
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Zoom Out'
                });
            });
        }

        window.showOptions = function(){
            $('#map .menu .options').css('width', '');
            $('#map .menu .options').show();
            $('#map .menu .options .list').css('height', 'auto');
            var h = $('#map .menu .options .list').outerHeight();
            $('#map .menu .options').css('width', '0px');
            $('#map .menu .options .list').css('height', '0px');
            $('#map .menu .label').stop().animate({'margin-right' : '-100px'}, function complete(){
                $('#map .menu .options').stop().animate({'width' : '400px'}, function complete(){
                $('#map .menu .options .list').stop().animate({'height' : h+'px'});      
                });
            });
            gtag('event', 'ENGAGED', {
                'event_category': 'MEDIA', 
                'event_label': 'Maptool Menu - Open Menu'
            });
        }

        window.hideOptions = function(){
            $('#map .menu .options .list').stop().animate({'height' : '0px'}, function complete(){
                $('#map .menu .options').stop().animate({'width' : '0'}, function complete(){
                    $('#map .menu .options').hide();
                    $('#map .menu .label').stop().animate({'margin-right' : '0'});
                    $('#map .zoom').css('right', '0');
                });
            });
        }

        window.showLocations = function(){
            $('#map .zoom').css('right', '-100px');
            $('#map .menu .locations').css('width', '');
            $('#map .menu .locations').show();
            $('#map .menu .locations .list').css('height', 'auto');
            var h = $('#map .menu .locations .list').outerHeight();
            $('#map .menu .locations').css('width', '0px');
            $('#map .menu .locations .list').css('height', '0px');
            $('#map .menu .options').stop().animate({'width' : '0px'}, function complete(){
              $('#map .menu .locations').stop().animate({'width' : '400px'}, function complete(){
                $('#map .menu .locations .list').stop().animate({'height' : h+'px'});      
              });
            });
            gtag('event', 'ENGAGED', {
                'event_category': 'MEDIA', 
                'event_label': 'Maptool Menu - Show Display Locations'
            });
        }
        window.hideLocations = function(){
            $('#map .menu .locations .list').stop().animate({'height' : '0px'}, function complete(){
              $('#map .menu .locations').stop().animate({'width' : '0'}, function complete(){
                $('#map .menu .locations').hide();
                showOptions();
                $('#map .zoom').css('right', '0');
              });
            });
        }
        window.showHlpLocations = function(){
            $('#map .zoom').css('right', '-100px');
            $('#map .menu .hlp-locations').css('width', '');
            $('#map .menu .hlp-locations').show();
            $('#map .menu .hlp-locations .list').css('height', 'auto');
            var h = $('#map .menu .hlp-locations .list').outerHeight();
            $('#map .menu .hlp-locations').css('width', '0px');
            $('#map .menu .hlp-locations .list').css('height', '0px');
            $('#map .menu .options').stop().animate({'width' : '0px'}, function complete(){
              $('#map .menu .hlp-locations').stop().animate({'width' : '400px'}, function complete(){
                $('#map .menu .hlp-locations .list').stop().animate({'height' : h+'px'});      
              });
            });
            gtag('event', 'ENGAGED', {
                'event_category': 'MEDIA', 
                'event_label': 'Maptool Menu - Show House and Land Packages'
            });
        }
        window.hideHlpLocations = function(){
            $('#map .menu .hlp-locations .list').stop().animate({'height' : '0px'}, function complete(){
              $('#map .menu .hlp-locations').stop().animate({'width' : '0'}, function complete(){
                $('#map .menu .hlp-locations').hide();
                showOptions();
                $('#map .zoom').css('right', '0');
              });
            });
        }
        window.showHouses = function(id){
            $('#map .menu .label').css('margin-right', '-100px');
            $('#map .zoom').css('right', '-100px');
            $('#map .menu .options').hide();
            $('#map .menu .houses').hide();
            $('#map .menu .hlp-locations').hide();
            $('#map .menu .hlps').hide();
            $('#map .menu .houses[data-id="'+id+'"]').css('width', '');
            $('#map .menu .houses[data-id="'+id+'"]').show();
            $('#map .menu .houses[data-id="'+id+'"] .list').css('height', 'auto');
            var h = $('#map .menu .houses[data-id="'+id+'"] .list').outerHeight();
            $('#map .menu .houses[data-id="'+id+'"]').css('width', '0px');
            $('#map .menu .houses[data-id="'+id+'"] .list').css('height', '0px');
            $('#map .menu .locations .list').stop().animate({'height' : '0px'}, function complete(){
              $('#map .menu .locations').stop().animate({'width' : '0px'}, function complete(){
                $('#map .menu .houses[data-id="'+id+'"]').stop().animate({'width' : '400px'}, function complete(){
                  $('#map .menu .houses[data-id="'+id+'"] .list').stop().animate({'height' : h+'px'});      
                  $('#map .menu .locations').hide();
                });
              });
            });
            gtag('event', 'ENGAGED', {
                'event_category': 'MEDIA', 
                'event_label': 'Maptool Menu - Show Display Location '+$('#map .menu .locations .list .item[data-id="'+id+'"] .name').text()
            });
        }
        window.hideHouses = function(){
            unclickAllMarkers();
            $('#map .menu .locations').css('width', '');
            $('#map .menu .locations').show();
            $('#map .menu .locations .list').css('height', 'auto');
            var h = $('#map .menu .locations .list').outerHeight();
            $('#map .menu .locations').css('width', '0px');
            $('#map .menu .locations .list').css('height', '0px');
            $('#map .menu .houses:visible .list').stop().animate({'height' : '0px'}, function complete(){
              $('#map .menu .houses:visible').stop().animate({'width' : '0'}, function complete(){
                $('#map .menu .locations').stop().animate({'width' : '400px'}, function complete(){
                  $('#map .menu .locations .list').stop().animate({'height' : h+'px'});      
                  $('#map .menu .houses').hide();
                });
              });
            });
        }
        window.showHlps = function(id){
            $('#map .menu .label').css('margin-right', '-100px');
            $('#map .zoom').css('right', '-100px');
            $('#map .menu .hlps').hide();
            $('#map .menu .options').hide();
            $('#map .menu .houses').hide();
            $('#map .menu .locations').hide();
            $('#map .menu .hlps[data-id="'+id+'"]').css('width', '');
            $('#map .menu .hlps[data-id="'+id+'"]').show();
            $('#map .menu .hlps[data-id="'+id+'"] .list').css('height', 'auto');
            var h = $('#map .menu .hlps[data-id="'+id+'"] .list').outerHeight();
            $('#map .menu .hlps[data-id="'+id+'"]').css('width', '0px');
            $('#map .menu .hlps[data-id="'+id+'"] .list').css('height', '0px');
            $('#map .menu .hlp-locations .list').stop().animate({'height' : '0px'}, function complete(){
              $('#map .menu .hlp-locations').stop().animate({'width' : '0px'}, function complete(){
                $('#map .menu .hlps[data-id="'+id+'"]').stop().animate({'width' : '400px'}, function complete(){
                  $('#map .menu .hlps[data-id="'+id+'"] .list').stop().animate({'height' : h+'px'});      
                  $('#map .menu .hlp-locations').hide();
                });
              });
            });
            gtag('event', 'ENGAGED', {
                'event_category': 'MEDIA', 
                'event_label': 'Maptool Menu - Show House and Land Location '+$('#map .menu .hlp-locations .list .item[data-id="'+id+'"] .name').text()
            });
        }

        window.hideHlps = function(){
            unclickAllMarkers();
            $('#map .menu .hlp-locations').css('width', '');
            $('#map .menu .hlp-locations').show();
            $('#map .menu .hlp-locations .list').css('height', 'auto');
            var h = $('#map .menu .hlp-locations .list').outerHeight();
            $('#map .menu .hlp-locations').css('width', '0px');
            $('#map .menu .hlp-locations .list').css('height', '0px');
            $('#map .menu .hlps:visible .list').stop().animate({'height' : '0px'}, function complete(){
              $('#map .menu .hlps:visible').stop().animate({'width' : '0'}, function complete(){
                $('#map .menu .hlp-locations').stop().animate({'width' : '400px'}, function complete(){
                  $('#map .menu .hlp-locations .list').stop().animate({'height' : h+'px'});      
                  $('#map .menu .hlps').hide();
                });
              });
            });
        }

        window.showHlp = function(id){
            $('#map .menu .houses:visible .list').stop().animate({'height' : '0px'}, function complete(){
              $('#map .menu .houses:visible').stop().animate({'width' : '0'}, function complete(){
                $('#map .menu .label').stop().animate({'margin-right' : '0'});
                $('#map .zoom').css('right', '0');
              });
            });
            var $form = $('.js-maptool-hlp-form');
            $form.find('[name="id"]').val(id);
            $form.find('.ajax-submit').trigger('click');
        }
        
        window.showHouse = function(home_id, location_id){
            $('#map .menu .houses:visible .list').stop().animate({'height' : '0px'}, function complete(){
              $('#map .menu .houses:visible').stop().animate({'width' : '0'}, function complete(){
                $('#map .menu .label').stop().animate({'margin-right' : '0'});
                $('#map .zoom').css('right', '0');
              });
            });
            var $form = $('.js-maptool-home-form');
            $form.find('[name="home_id"]').val(home_id);
            $form.find('[name="location_id"]').val(location_id);
            $form.find('.ajax-submit').trigger('click');
        }
        window.showHouseAlt = function(home_id, location_id){
            var $form = $('.js-maptool-home-form');
            $form.find('[name="home_id"]').val(home_id);
            $form.find('[name="location_id"]').val(location_id);
            $form.find('.ajax-submit').trigger('click');
        }
        window.hideHouse = function(){
            if($(window).width() > 1800){
              $('#map .home').css('margin-left', '-50%');
              $('#map .overlay').css('margin-right', '-50%');
            }else{
              $('#map .home').css('margin-left', '-960px');
              $('#map .overlay').css('margin-right', '-120px');
            }
            $('#map .gmap').css('margin-left', '0');
            unclickAllMarkers();
        }
          
        window.showEmail = function(home_or_package){
            $('#map .home .buttons .btn.blue').attr('onclick', '');
            $('#map .home .detail').css('overflow', 'hidden');      
            $('#map .home .detail').animate({scrollTop : 0});
            $('#map .home .detail').animate({'height' : '490px'});
            $('#map .home .email').animate({'margin-bottom' : '0'});
            $('#map .home .email [name="home_or_package"]').val(home_or_package);
            $('#map .home .top').animate({'margin-top' : '80px'});
            if($(window).width() > 1800){
              $('#map .home .buttons').animate({'margin-bottom' : '1000px'}, function complete(){
                $('#map .home .buttons .btn.blue').animate({'width' : '100%'});
                $('#map .home .buttons .btn.grey').animate({'width' : '0'});
              });
            }else{
              $('#map .home .buttons').animate({'margin-bottom' : '1840px'}, function complete(){
                $('#map .home .buttons .btn.blue').animate({'width' : '100%'});
                $('#map .home .buttons .btn.grey').animate({'width' : '0'});
              });
            }
            gtag('event', 'ENGAGED', {
                'event_category': 'ENQUIRY', 
                'event_label': 'Email Form - Show Email Form'
            });
        }
          
        window.showImage = function(){
            $('#map .home .blowup.img').show();
            $('#map .home .blowup.img').css('opacity', '0');
            $('#map .home .blowup.img').stop().animate({'opacity' : '1'});
        }
        window.showFloorplan = function(){
            $('#map .home .blowup.floorplan').show();
            $('#map .home .blowup.floorplan').css('opacity', '0');
            $('#map .home .blowup.floorplan').stop().animate({'opacity' : '1'});
        }
        window.hideImage = function(){
            $('#map .home .blowup').stop().animate({'opacity' : '0'}, function complete(){      
                $('#map .home .blowup').hide();
            });
        }
        window.initKeyboard = function(){
            $('#map .home input[type=text], #map .home input[type=password], #map .home textarea, #map .home input[type=textarea], #map .home input[type=email]').keyboard({
              usePreview: false,
              autoAccept: true,
              display: {
                'bksp': " Backspace",
                'accept': 'Enter',
                'default': 'ABC',
                'meta1': '.?123',
                'meta2': '#+='
              },
        
              layout: 'custom',
              customLayout: {
                'default': ['q w e r t y u i o p {bksp}',
                  '{bksp} a s d f g h j k l @',
                  '{s} z x c v b n m , .',
                  '{meta1} {space} {meta1} {accept}'
                ],
                'shift': ['Q W E R T Y U I O P {bksp}',
                  'A S D F G H J K L ',
                  '{s} Z X C V B N M ! ?',
                  '{meta1} {space} {meta1} {accept}'
                ],
                'meta1': ['1 2 3 4 5 6 7 8 9 0 {bksp}',
                  '- / : ; ( ) \u20ac & @ ',
                  '{meta2} . , ? ! \' " {meta2}',
                  '{default} {space} {default} {accept}'
                ],
                'meta2': ['[ ] { } # % ^ * + = {bksp}',
                  '_ \\ | ~ < > $ \u00a3 \u00a5 ',
                  '{meta1} . , ? ! \' " {meta1}',
                  '{default} {space} {default} {accept}'
                ]
              }
        
            });
        }
    };

    return {
        init: init
    };
};

export default MaptoolMap;